import { IconButton, Stack } from '@mui/material'
import { Icon } from '@mxenabled/mx-icons'
import { Text } from '@mxenabled/mxui'

interface CopyContent {
  decrement_arial_label?: string
  increment_arial_label?: string
}

interface BalanceStepperProps {
  amount: string
  onDecrement?: () => void
  onIncrement?: () => void
  copy: CopyContent
}

export const BalanceStepper = ({ amount, onDecrement, onIncrement, copy }: BalanceStepperProps) => {
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        bgcolor: 'background.paper',
        flex: 1,
      }}
    >
      <IconButton
        aria-label={copy.decrement_arial_label}
        onClick={onDecrement}
        sx={{ width: 44, minHeight: 48 }}
      >
        <Icon name="remove" sx={{ color: 'primary.main' }} />
      </IconButton>
      <Text
        sx={{
          p: 12,
          flex: 1,
          textAlign: 'center',
          borderLeft: '1px solid',
          borderRight: '1px solid',
          borderColor: 'divider',
        }}
        variant="h3"
      >
        {amount}
      </Text>
      <IconButton
        aria-label={copy.increment_arial_label}
        onClick={onIncrement}
        sx={{ width: 44, minHeight: 48 }}
      >
        <Icon name="add" sx={{ color: 'primary.main' }} />
      </IconButton>
    </Stack>
  )
}
